import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    //テキスト
      textField: {
        flexGrow: 1,
        height: '100%',
        width: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        textAlign: "center",
    },
    tableNameeCell: {
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'center',
      fontSize: '15px',
      borderBottomWidth: '0px',
    },
    tableTitleCell: {
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'right',
      fontSize: '15px',
      borderBottomWidth: '0px',
    },
    tableCell: {
      border: '1px solid rgba(0, 0, 0, 1)',
      backgroundColor: 'white',
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'center',
    },
    tableSelectCell: {
      border: '1px solid rgba(0, 0, 0, 1)',
      backgroundColor: '#FFFFBB',
      maxWidth: '30px',
      minWidth: '30px',
      padding: '1px',
      textAlign: 'center',
    },
  })
);

export const OffLineJudgeStyle = makeStyles(
  createStyles({
     paperRoot: {
      maxWidth: '600px',
      minWidth: '400px',
      padding: '5px',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);

export const  OffLineJudgeGraphStyle = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 434px)',
      maxHeight: 'calc(100vh - 434px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      width: '100px',
      maxHeight: '35px',
      minHeight: '35px',
      marginLeft: '40px',
      alignItems: 'center',
    },
    customTooltip: {
      background: '#FFFFEE',
      fontSize: '14px',
      padding: '10px 10px 0px 20px',
    }
  })
);
